import { sendStileEventCall } from "../../../javascript/stilePhetInterface";

export class Application {
    constructor() {
        window.addEventListener("resize", () => this.resize(), false);
    }

    resize() {
        this.wrapper = document.querySelector("#sim");
        this.width = window.innerWidth;
        this.height = Math.floor(0.6 * this.width);

        if (this.wrapper) {
            this.wrapper.style.height = this.height + "px";
        }

        // resize our stile window
        try {
            try {
                sendStileEventCall("changeWindowDimensions");
            } catch (e) {
                console.log(e);
            }
        } catch (e) {
            console.log("Failed to find Stile Interface");
        }
    }
}
